import React from 'react';
import AdThumb from './AdThumb';
import AdInfo from './AdInfo';

const AdItem = ({
  src,
  profileSrc,
  advertiser,
  title,
  videoUrl,
  adUrl,
  trackingEvents,
  clickLogUrl
}) => {
    return (
        <>
            <AdThumb src={src} videoUrl={videoUrl} adUrl={adUrl} trackingEvents={trackingEvents} clickLogUrl={clickLogUrl}/>
            <AdInfo profileSrc={profileSrc} advertiser={advertiser} title={title} adUrl={adUrl} clickLogUrl={clickLogUrl} />
        </>
    );
};

export default AdItem;